import styled from "styled-components"
import { breakpoint, colour } from "@/styles/variables"

const Layout = styled.div`
  min-height: calc(100vh - 60px);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: ${breakpoint.max.large}) {
    min-height: calc(100vh - 70px);
  }
`

export default Layout
